import { render, staticRenderFns } from "./AppDropzone.vue?vue&type=template&id=3ba3a0d4&"
import script from "./AppDropzone.vue?vue&type=script&lang=js&"
export * from "./AppDropzone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports